import Animate from './Animate';
import AnimateChild from './AnimateChild';
import CSSMotion from './CSSMotion';

export { AnimateChild, CSSMotion };

export default Animate;


//////////////////
// WEBPACK FOOTER
// ./~/rc-tree-select/~/rc-animate/es/index.js
// module id = 1136
// module chunks = 0